export const PRACTITIONER_PATH = "/practitioner";
export const PRACTITIONERS_LIST = `/practitioners`;
export const PRACTITIONER_ROUTE_PATH = `${PRACTITIONER_PATH}/:practitionerId/:slug?`;
